import { DomainModelHelper } from '@digital-platform/shared/domain';
import { ExpressWasteProfileMeta } from '../interfaces';

interface SectionMeta {
  readonly completed: boolean;
  readonly valid: boolean;
}

class SectionMetaModel implements SectionMeta {
  public constructor(data?: SectionMeta) {
    Object.assign(this, SectionMetaModel.DEFAULT_CONFIG);

    if (data?.completed !== undefined) {
      this.completed = DomainModelHelper.ensureDataIsBoolean(data.completed);
    }
    if (data?.valid !== undefined) {
      this.valid = DomainModelHelper.ensureDataIsBoolean(data.valid);
    }
  }

  public static DEFAULT_CONFIG: SectionMeta = {
    completed: false,
    valid: false,
  };
  public readonly completed: boolean;
  public readonly valid: boolean;
}

export class ExpressWasteProfileMetaModel implements ExpressWasteProfileMeta {
  public static DEFAULT_CONFIG: ExpressWasteProfileMeta = {
    sections: {
      generator: {
        completed: false,
        valid: false,
      },
      billing: {
        completed: false,
        valid: false,
      },
      authorization: {
        completed: false,
        valid: false,
      },
      wasteStream: {
        completed: false,
        valid: false,
      },
      attachments: {
        completed: false,
        valid: false,
      },
      destination: {
        completed: false,
        valid: false,
      },
      checkList: {
        completed: false,
        valid: false,
      },
      signature: {
        completed: false,
        valid: false,
      },
    },
  };

  public readonly sections: {
    readonly generator: SectionMeta;
    readonly billing: SectionMeta;
    readonly authorization: SectionMeta;
    readonly wasteStream: SectionMeta;
    readonly attachments: SectionMeta;
    readonly destination: SectionMeta;
    readonly checkList: SectionMeta;
    readonly signature: SectionMeta;
  };

  public constructor(data?: ExpressWasteProfileMeta) {
    Object.assign(this, ExpressWasteProfileMetaModel.DEFAULT_CONFIG);

    if (data?.sections?.generator !== undefined) {
      this.sections = {
        ...this.sections,
        generator: new SectionMetaModel(data.sections.generator),
      };
    }
    if (data?.sections?.billing !== undefined) {
      this.sections = {
        ...this.sections,
        billing: new SectionMetaModel(data.sections.billing),
      };
    }
    if (data?.sections?.authorization !== undefined) {
      this.sections = {
        ...this.sections,
        authorization: new SectionMetaModel(data.sections.authorization),
      };
    }
    if (data?.sections?.wasteStream !== undefined) {
      this.sections = {
        ...this.sections,
        wasteStream: new SectionMetaModel(data.sections.wasteStream),
      };
    }
    if (data?.sections?.attachments !== undefined) {
      this.sections = {
        ...this.sections,
        attachments: new SectionMetaModel(data.sections.attachments),
      };
    }
    if (data?.sections?.destination !== undefined) {
      this.sections = {
        ...this.sections,
        destination: new SectionMetaModel(data.sections.destination),
      };
    }
    if (data?.sections?.checkList !== undefined) {
      this.sections = {
        ...this.sections,
        checkList: new SectionMetaModel(data.sections.checkList),
      };
    }
    if (data?.sections?.signature !== undefined) {
      this.sections = {
        ...this.sections,
        signature: new SectionMetaModel(data.sections.signature),
      };
    }
  }
}
